import { render, staticRenderFns } from "./communityComplaintAdvice.vue?vue&type=template&id=543c7a51&scoped=true&"
import script from "./communityComplaintAdvice.vue?vue&type=script&lang=js&"
export * from "./communityComplaintAdvice.vue?vue&type=script&lang=js&"
import style0 from "./communityComplaintAdvice.vue?vue&type=style&index=0&id=543c7a51&prod&lang=less&scoped=true&"
import style1 from "./communityComplaintAdvice.vue?vue&type=style&index=1&id=543c7a51&prod&lang=less&"
import style2 from "./communityComplaintAdvice.vue?vue&type=style&index=2&id=543c7a51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c7a51",
  null
  
)

export default component.exports